export default "__VITE_ASSET__DjGN8grH__"